import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ImageResponseGet } from '../../../../../models/api-dam/image/image-response.model';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GalleryRequest } from '../../../../../models/api-dam/gallery/gallery-request.model';
import { ImmaginiCreateComponent } from '../../immagini/immagini-create/immagini-create.component';
import { LoadImageFromDamComponent } from '../../../../../components/ui/load-image-from-dam/load-image-from-dam.component';
import { ImageService } from '../../../../../services/api-dam/image/image.service';
import { GalleryService } from '../../../../../services/api-dam/gallery/gallery.service';
import { DIALOG_LARGE_CONFIG } from '../../../../../utils/config/modal-settings';
import { LOADINGIMAGE } from '../../../../../utils/config/image-settings';
import { FALSE, TRUE } from '../../../../../utils/config/const';
import { UtilsService } from '../../../../../services/utils-folder/utils.service';

@Component({
  selector: 'app-gallerie-edit',
  templateUrl: './gallerie-edit.component.html',
  styleUrls: ['./gallerie-edit.component.css']
})
export class GallerieEditComponent implements OnInit {

  id: number;
  formBuilder: FormGroup;
  request: any = {};
  goBackUrl: string = "/dam/gallerie";
  imageChoice: ImageResponseGet = new ImageResponseGet();
  visibleImageChoice: boolean = false;
  isButtonSaveDisabled: boolean;
  public imagesList: any = [];
  public imagesMapList: any = {};



  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private imageService: ImageService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private galleryService: GalleryService,
    private utilsService: UtilsService
  ) {
    this.id = this.route.snapshot.params['id'];
    this.imageChoice = new ImageResponseGet();
    this.visibleImageChoice = false;
    this.initForm();
  }

  ngOnInit(): void {
    this.loadDataByID(this.id);
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }


  loadDataByID(idObj) {
    this.spinner.show();
    this.galleryService.get(idObj).subscribe(
      (response) => {
        if (response) {
          this.setFormValue(response);
          this.setListImage(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni della galleria', 'Caricamento galleria', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }


  initForm() {
    this.formBuilder = this.fb.group({
      name: ["", Validators.required],
      previewImage: [""],
      seoId: [""]
    });
  }

  getFormValue() {
    let request = new GalleryRequest();
    request.name = this.formBuilder.controls['name'].value;
    request.previewImage = this.formBuilder.controls['previewImage'].value;
    request.seoId = this.formBuilder.controls['seoId'].value;
    return request;
  }

  getImagesRequest(result) {
    let request = [];
    let imagesList = [];
    for (let i = 0; i < result.length; i++) {
      imagesList.push(result[i].id);
      if (result.length - 1 === i) {
        request = imagesList;
        this.saveImages(request);
      }
    }
  }

  setFormValue(response) {
    this.formBuilder.controls['name'].setValue(response.name);
    this.formBuilder.controls['seoId'].setValue(response.seoId);
    if (response.previewImage != null && typeof response.previewImage != typeof undefined) {
      this.formBuilder.controls['previewImage'].setValue(response.previewImage.id);
      this.loadImage(this.formBuilder.controls['previewImage'].value);
    }
  }




  save() {
    this.request = this.getFormValue();
    this.galleryService.update(this.id, this.request).subscribe(
      (response) => {
        if (response) {
          //Salvata modifica
          this.toastr.success('Galleria modificata con successo', 'Modifica Galleria', {
            timeOut: 5000
          });
          this.router.navigate([this.goBackUrl]);
        }
        this.isButtonSaveDisabled = true;
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la modifica della galleria', 'Modifica Galleria', {
          timeOut: 5000
        });
        this.isButtonSaveDisabled = true;
        this.spinner.hide();
      }
    );
  }


  /**
   * Azione click su button Carica da PC
   */
  openLoadImageFromPC() {
    //Apre modale di create
    const modalRef = this.modalService.open(ImmaginiCreateComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        let id = result.id;
        if (this.formBuilder.controls['previewImage'].value != parseInt(id)) {
          this.formBuilder.controls['previewImage'].setValue(id);
          this.formBuilder.controls['previewImage'].markAsTouched();
          this.loadImage(this.formBuilder.controls['previewImage'].value);
        }
      }
    });
  }



  /**
   * Azione click su button carica da D.A.M
   */
  openLoadImageFromDAM() {
    //Apertura modale di modifica 
    let value = this.formBuilder.controls['previewImage'].value;
    const modalRef = this.modalService.open(LoadImageFromDamComponent, DIALOG_LARGE_CONFIG);
    if (value == "" || value == null) {
      value = [];
    } else {
      value = [value];
    }
    modalRef.componentInstance.multiple = false;
    modalRef.componentInstance.idImages = value;
    modalRef.result.then((result: any) => {
      if (result && result != "CLOSE") {
        if (result.images.length > 0) {
          if (this.formBuilder.controls['previewImage'].value != parseInt(result.images[0].id)) {
            this.formBuilder.controls['previewImage'].setValue(result.images[0].id);
            this.formBuilder.controls['previewImage'].markAsTouched();
            this.loadImage(this.formBuilder.controls['previewImage'].value);
          }
        } else {
          this.imageChoice = this.imageChoice = new ImageResponseGet();
          this.visibleImageChoice = false;
          this.formBuilder.controls['previewImage'].setValue(null);
          this.formBuilder.controls['previewImage'].markAsTouched();
        }
      }
    });
  }


  openLoadListOfImageFromDAM() {
    //Apertura modale di modifica
    let value = Object.keys(this.imagesMapList);
    const modalRef = this.modalService.open(LoadImageFromDamComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.multiple = true;
    modalRef.componentInstance.idImages = value;
    modalRef.result.then((result: any) => {
      if (result && result != "CLOSE") {
        this.imagesList = [];
        this.imagesMapList = {};
        if (result.images.length > 0) {
          this.setListImage(result);
          this.getImagesRequest(result.images);
        }
      }
    });
  }

  saveImages(request) {
    this.galleryService.images(this.id, request).subscribe(
      (response) => {
        if (response) {
          //Salvata modifica
          this.toastr.success('Galleria modificata con successo', 'Modifica Galleria', {
            timeOut: 5000
          });
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la modifica della galleria', 'Modifica Galleria', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  /**
 * Setta le informazioni della response 
 * */
  setListImage(response) {
    if (response.images != null && typeof response.images != typeof undefined) {
      let data = response.images
      for (let i = 0; i < data.length; i++) {
        this.insertListOfImages(data[i], i);
      }

    }
  }

  insertListOfImages(imageObj, pos) {
    let idImage = imageObj.id;
    this.imagesMapList[idImage] = pos;
    if (imageObj.published === FALSE) {
      imageObj.url = LOADINGIMAGE;
    }
    this.imagesList.push(imageObj);
    if (imageObj.published === FALSE) {
      this.downloadListOfImages(idImage);
    }
  }


  deleteImage() {
    this.imageChoice = new ImageResponseGet();
    this.visibleImageChoice = false;
    this.formBuilder.controls['previewImage'].setValue(null);
    this.formBuilder.controls['previewImage'].markAsTouched();
  }


  loadImage(id) {
    this.visibleImageChoice = true;
    this.imageService.getEntity(id).subscribe(
      (response) => {
        this.insertImage(response);
      },
      (error) => {
        this.toastr.error('Si è verificato un errore durante il caricamento dell\'immagine', 'Caricamento immagine fallita', {
          timeOut: 5000
        });
      }
    );
  }

  insertImage(imageObj) {
    this.imageChoice = imageObj;
    let idImage = imageObj.id;
    if (imageObj.published === FALSE) {
      this.imageChoice.url = LOADINGIMAGE;
    }
    if (imageObj.published === FALSE) {
      this.downloadImage(idImage);
    }
  }
  /**
   * Carica immagine non pubblica
   * @param idImage 
   */
  downloadImage(idImage) {
    this.imageService.download(idImage).subscribe(
      (response) => {
        this.imageChoice.url = this.utilsService.getSecurityTrustURL(response);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.imageChoice.url = "/assets/images/no-image-icon.png";
      }
    );
  }

  downloadListOfImages(idImage) {
    this.imageService.download(idImage).subscribe(
      (response) => {
        this.imagesList[this.imagesMapList[idImage]].url = this.utilsService.getSecurityTrustURL(response);
      },
      (error: HttpErrorResponse) => {
        this.imagesList[this.imagesMapList[idImage]].url = "/assets/images/no-image-icon.png";
      }
    );
  }





  /**
   * Azione click su button salva modifiche
   */
  clickButtonSave() {
    if (this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE) {
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }


  /**
   * Azione click su button Annulla
   */
  clickButtonCancel() {
    //Torna indietro alla tabella
    this.router.navigate([this.goBackUrl]);
  }

  /**
 * Azione sull'immagine - Cancella
 * @param idImage 
 */
  clickButtonDeleteImage(idImage) {
    this.imagesList.splice(this.imagesList.findIndex(function (i) {
      return i.id === idImage;
    }), 1);
    delete this.imagesMapList[idImage];
    this.getImagesRequest(this.imagesList);

  }

  clickButtonGetUrlImage(urlImage) {
    let temporaryInput = document.createElement('input');
    document.body.appendChild(temporaryInput);
    temporaryInput.value = urlImage;
    temporaryInput.select();
    temporaryInput.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(temporaryInput.value);
    document.body.removeChild(temporaryInput);
  }

}
